var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "service-list-container" } }, [
    _c(
      "div",
      {
        staticClass: "grid-x grid-padding-x services-grid-container",
        attrs: { id: "service-grid" },
      },
      [
        _vm._l(_vm.services, function (service) {
          return _c("service-card", {
            key: service.id,
            attrs: { service: service },
          })
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "large-12 medium-12 small-12 cell no-results",
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }